export default __webpack_public_path__ + "static/media/_IMG5549-Edit.5e70c19d.jpg";